import { CSSProperties } from 'react';

type CSSValue = CSSProperties[keyof CSSProperties];
type StyleObject = Record<string, CSSValue | Record<string, CSSValue>>;

export const mediaUp = (breakpoint: number, styles: StyleObject) => ({
  [`@media (min-width: ${breakpoint}px)`]: styles,
});

export const mediaDown = (breakpoint: number, styles: StyleObject) => ({
  [`@media (max-width: ${breakpoint - 1}px)`]: styles,
});

export const mediaBetween = (min: number, max: number, styles: StyleObject) => ({
  [`@media (min-width: ${min}px) and (max-width: ${max - 1}px)`]: styles,
});

export const hideBelow = (breakpoint: number) => ({
  [`@media (max-width: ${breakpoint - 1}px)`]: {
    display: 'none',
  },
});

export const hideAbove = (breakpoint: number) => ({
  [`@media (min-width: ${breakpoint}px)`]: {
    display: 'none',
  },
});
